import {
  AfterContentChecked,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { StoreService } from 'src/app/core/services/store.service';
import { environment } from 'src/environments/environment';
import { AvatarModule } from 'ngx-avatars';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { FormsModule } from '@angular/forms';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    AvatarModule,
    RouterModule,
    CommonModule,
    MatSelectModule,
    MatOptionModule,
    FormsModule,
  ],
})
export class HeaderComponent implements OnInit, AfterContentChecked {
  bizName: string | any;
  @Input() storeName: any;
  showImage: boolean = false;
  @Input() type: 'hero' | 'default' = 'default';

  @Output() searchTermChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() filterWithPrice: EventEmitter<any> = new EventEmitter<any>();
  @HostListener('window:scroll', [])
  selectedOption = 'All categories';
  readonly options = [
    'All categories',
    'High to Low price',
    'Low to High price',
  ];

  filter: any;
  displayName: any;
  setupStoreLink: string = '';
  active!: boolean;
  imageLink: string = '';
  bannerLink: string = '';

  constructor(public store: StoreService) {
    this.setupStoreLink = environment.SETUP_STORE_URL;
  }

  onSearchTermChange(event: any) {
    this.searchTermChanged.emit(event);
  }

  onSearchIconClick(searchValue: string) {
    this.searchTermChanged.emit({ target: { value: searchValue } });
  }

  onFilterWithPrice(change: MatSelectChange): void {
    this.selectedOption = change.value;
    this.filterWithPrice.emit(change);
  }

  showPicture() {
    this.store.getPicture(this.storeName?.slug).subscribe({
      next: (res: any) => {
        const imageArray = res.imageData;
        imageArray.forEach((item: any) => {
          if (item.file_group === 'PROFILE_IMG') {
            this.imageLink = item.image_source;
          } else if (item.file_group === 'BANNER_IMG') {
            this.bannerLink = item.image_source;
          }
        });
      },
    });
  }

  openFilter() {
    this.filter = !this.filter;
  }
  ngOnInit(): void {
    this.bizName = this.storeName?.slug;
    if (this.storeName) {
      this.active = this.storeName?.active;
      this.showPicture();
    }
  }

  ngAfterContentChecked(): void {
    this.displayName = this.storeName?.storeName;
    this.bizName = this.storeName?.slug;
  }
}
